import React from 'react';
import type {IconButtonProps} from '@tempo/core';
import {IconButton} from '@tempo/core';
import type {TdProps} from '../core/Td';
import Td from '../core/Td';
import Tooltip from '@components/Tooltip';

export type IconButtonCellProps = {
	iconButtonProps?: Omit<IconButtonProps, 'icon' | 'aria-label'> & {
		['data-testid']?: string;
	};
	icon?: IconButtonProps['icon'];
	onClick?: IconButtonProps['onClick'];
	['aria-label']: IconButtonProps['aria-label'];
	tooltip?: React.ReactNode;
} & Omit<TdProps, 'onClick'>;

const IconButtonCell = ({
	iconButtonProps,
	onClick,
	icon,
	'aria-label': ariaLabel,
	tooltip,
	...rest
}: IconButtonCellProps) => {
	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	const content = (
		<IconButton
			variant="ghost"
			size="small"
			aria-label={ariaLabel || ''}
			onClick={handleClick}
			{...iconButtonProps}
			icon={icon}
		/>
	);

	return (
		<Td px="spacing.s" {...rest}>
			{tooltip ? (
				<Tooltip placement="auto" label={tooltip}>
					{content}
				</Tooltip>
			) : (
				content
			)}
		</Td>
	);
};

export default IconButtonCell;
